import React from 'react'
import 'react-toastify/dist/ReactToastify.css';
import { StaticImage } from "gatsby-plugin-image"

const ContactForm = () => {

    const contactForm = `
<!-- Note :
   - You can modify the font style and form style to suit your website. 
   - Code lines with comments Do not remove this code are required for the form to work properly, make sure that you do not remove these lines of code. 
   - The Mandatory check script can modified as to suit your business needs. 
   - It is important that you test the modified form before going live.-->
<div id = 'crmWebToEntityForm' class = 'zcwf_lblLeft crmWebToEntityForm' style = 'background-color: white;color: black;max-width: 600px;'>
	<meta name = 'viewport' content = 'width=device-width, initial-scale=1.0'>
		<META HTTP-EQUIV = 'content-type' CONTENT = 'text/html;charset=UTF-8'>
			<form id = 'webform6383044000000668002' action = 'https://crm.zoho.com/crm/WebToLeadForm' name = WebToLeads6383044000000668002 method = 'POST' onSubmit = 'javascript:document.charset="UTF-8"; return checkMandatory6383044000000668002()' accept-charset = 'UTF-8'>
				<input type = 'text' style = 'display:none;' name = 'xnQsjsdp' value = 'e36b3aadce6fe3493b23acafd98635b8ba0228447d5f0ea97b1c3fc77463d6b7'>
				</input>
				<input type = 'hidden' name = 'zc_gad' id = 'zc_gad' value = ''>
				</input>
				<input type = 'text' style = 'display:none;' name = 'xmIwtLD' value = '633cd80e0a2989a516872d08fc92404b26a1f6cd190f7f3c5dab9d0422b46b7bdd97ff0f4f44eb0fc0550628195b9359'>
				</input>
				<input type = 'text' style = 'display:none;' name = 'actionType' value = 'TGVhZHM='>
				</input>
				<input type = 'text' style = 'display:none;' name = 'returnURL' value = 'https&#x3a;&#x2f;&#x2f;dochase.com&#x2f;success&#x2f;'>
				</input>
				<!-- Do not remove this code. -->
				<style>
					html,body{
						margin: 0px;
					}
					#crmWebToEntityForm.zcwf_lblLeft{
						width: 100%;
						margin: 0 auto;
						box-sizing: border-box;
					}
					#crmWebToEntityForm.zcwf_lblLeft *{
						box-sizing: border-box;
					}
					#crmWebToEntityForm {text-align: left;
					}
					#crmWebToEntityForm *{
					direction: ltr;
					}
                    .zcwf_lblLeft .zcwf_title {
                        word-wrap: break-word;
                        font-weight: bold
                    }
                    .zcwf_lblLeft.cpT_primaryBtn:hover {
                    background: linear-gradient(#02acff 0, #006be4 100%) no-repeat padding-box !important;
                    box-shadow: 0 -2px 0 0 #0159b9 inset !important;
                    border: 0 !important;
                    color: #fff !important;
                    outline: 0 !important;
                    }
					.zcwf_lblLeft .zcwf_col_fld input[type = text], input[type = password], .zcwf_lblLeft .zcwf_col_fld textarea{
					width: 100%;
					resize: vertical;
					border-radius: 6px;
					float: left;
					}
					.zcwf_lblLeft .zcwf_col_lab{
					width: 100%;
					word-break: break-word;
					margin-right: 10px;
					margin-top: 5px;
					float: left;
					min-height: 1px;
					}
					.zcwf_lblLeft .zcwf_col_fld{
					float: left;
					width: 100%;
					padding: 0px 6px 0px;
					position: relative;
					margin-top: 5px;
					}
					.zcwf_lblLeft .zcwf_privacy {padding: 6px;
					}
					.zcwf_lblLeft .wfrm_fld_dpNn {display: none;
					}
					.dIB {display: inline-block;
					}
					.zcwf_lblLeft .zcwf_col_fld_slt{
					width: 100%;
					background:  #F0F0F0;
					border-radius: 4px;
					font-size: 14px;
					float: left;
					resize: vertical;
					padding: 8px;
					}
                    .zcwf_row {
                        display: grid;
                    }
					.zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after{
					content: '';
					display: table;
					clear: both;
					}
					.zcwf_lblLeft .zcwf_col_help{
					float: left;
					margin-left: 7px;
					font-size: 14px;
					max-width: 35%;
					word-break: break-word;
					}
					.zcwf_lblLeft .zcwf_help_icon{
					cursor: pointer;
					width: 16px;
					height: 16px;
					display: inline-block;
					background:  #fff;
					border: 1px solid  #c0c6cc;
					color:  #c1c1c1;
					text-align: center;
					font-size: 11px;
					line-height: 16px;
					font-weight: bold;
					border-radius: 50%;
					}
					.zcwf_lblLeft .zcwf_row {margin: 15px 0px;
					}
					.zcwf_lblLeft .formsubmit{
					margin-right: 5px;
					cursor: pointer;
					font-size: 14px;
					}
					.zcwf_lblLeft .zcwf_privacy_txt{
					width: 90%;
					color: rgb(0, 0, 0);
					font-size: 14px;
					display: inline-block;
					vertical-align: top;
					color: var(--baseColor);
					padding-top: 2px;
					margin-left: 6px;
					}
					.zcwf_lblLeft .zcwf_button{
					font-size: 14px;
					padding: 10px;
					border-radius: 4px;
					cursor: pointer;
                    color: white;
                    width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
                    background-color: rgba(249, 37, 57, 1);
					}
					.zcwf_lblLeft .zcwf_tooltip_over{
					position: relative;
					}
					.zcwf_lblLeft .zcwf_tooltip_ctn{
					position: absolute;
					background:  #dedede;
					padding: 3px 6px;
					top: 3px;
					border-radius: 4px;
					word-break: break-word;
					min-width: 100px;
					max-width: 150px;
                    color: var(--baseColor);
					z-index: 100;
					}
					.zcwf_lblLeft .zcwf_ckbox{
					float: left;
					}
					.zcwf_lblLeft .zcwf_file{
					width: 55%;
					box-sizing: border-box;
					float: left;
					}
					.cBoth:after{
					content: '';
					display: block;
					clear: both;
					}
					@media all and  (max-width: 600px){
					.zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld{
					width: auto;
					float: none !important;
					}
					.zcwf_lblLeft .zcwf_col_help {width: 40%;
					}
					}
                    input {
                        padding: 0.375rem;
                        background-color: rgba(172, 172, 172, 0.25);
                        border-radius: 0.375rem;
                        border: none;
                    }
        
                    button {
                        width: 100%;
                    }
				</style>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'First_Name'>
							First Name
							<span style = 'color:red;'>
								*
							</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'First_Name' aria-required = 'true' aria-label = 'First Name' name = 'First Name' aria-valuemax = '40' maxlength = '40'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'Last_Name'>
							Last Name
							<span style = 'color:red;'>
								*
							</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'Last_Name' aria-required = 'true' aria-label = 'Last Name' name = 'Last Name' aria-valuemax = '80' maxlength = '80'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'Company'>
							Company
							<span style = 'color:red;'>
								*
							</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'Company' aria-required = 'true' aria-label = 'Company' name = 'Company' aria-valuemax = '200' maxlength = '200'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'Email'>
							Email
							<span style = 'color:red;'>
								*
							</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' ftype = 'email' autocomplete = 'false' id = 'Email' aria-required = 'true' aria-label = 'Email' name = 'Email' aria-valuemax = '100' crmlabel = '' maxlength = '100'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'Phone'>
							Phone
							<span style = 'color:red;'>
								*
							</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'Phone' aria-required = 'true' aria-label = 'Phone' name = 'Phone' aria-valuemax = '30' maxlength = '30'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'Country'>
							Country
							<span style = 'color:red;'>
								*
							</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'Country' aria-required = 'true' aria-label = 'Country' name = 'Country' aria-valuemax = '100' maxlength = '100'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row wfrm_fld_dpNn'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'Lead_Source'>
							Lead Source
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<select class = 'zcwf_col_fld_slt' role = 'combobox' aria-expanded = 'false' aria-haspopup = 'listbox' id = 'Lead_Source' onChange = 'addAriaSelected6383044000000668002()' aria-required = 'false' aria-label = 'Lead Source' name = 'Lead Source'>
							<option value = '-None-'>
								-None-
							</option>
							<option value = 'Advertisement'>
								Advertisement
							</option>
							<option value = 'Cold&#x20;Call'>
								Cold Call
							</option>
							<option value = 'Employee&#x20;Referral'>
								Employee Referral
							</option>
							<option value = 'External&#x20;Referral'>
								External Referral
							</option>
							<option value = 'Online&#x20;Store'>
								Online Store
							</option>
							<option value = 'X&#x20;&#x28;Twitter&#x29;'>
								X &#x28;Twitter&#x29;
							</option>
							<option value = 'Facebook'>
								Facebook
							</option>
							<option value = 'Partner'>
								Partner
							</option>
							<option value = 'Public&#x20;Relations'>
								Public Relations
							</option>
							<option value = 'Sales&#x20;Email&#x20;Alias'>
								Sales Email Alias
							</option>
							<option value = 'Seminar&#x20;Partner'>
								Seminar Partner
							</option>
							<option value = 'Internal&#x20;Seminar'>
								Internal Seminar
							</option>
							<option value = 'Trade&#x20;Show'>
								Trade Show
							</option>
							<option value = 'Events'>
								Events
							</option>
							<option selected value= 'Website'>
								Website
							</option>
							<option value = 'Chat'>
								Chat
							</option>
						</select>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row wfrm_fld_dpNn'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'LEADCF1'>
							utm_source
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'LEADCF1' aria-required = 'false' aria-label = 'LEADCF1' name = 'LEADCF1' aria-valuemax = '255' maxlength = '255' value = 'utm_source'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row wfrm_fld_dpNn'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'LEADCF2'>
							utm_medium
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'LEADCF2' aria-required = 'false' aria-label = 'LEADCF2' name = 'LEADCF2' aria-valuemax = '255' maxlength = '255' value = 'utm_medium'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row wfrm_fld_dpNn'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'LEADCF3'>
							utm_campaign
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'LEADCF3' aria-required = 'false' aria-label = 'LEADCF3' name = 'LEADCF3' aria-valuemax = '255' maxlength = '255' value = 'utm_campaign'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'Industry'>
							Industry
							<span style = 'color:red;'>
								*
							</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<select class = 'zcwf_col_fld_slt' role = 'combobox' aria-expanded = 'false' aria-haspopup = 'listbox' id = 'Industry' onChange = 'addAriaSelected6383044000000668002()' aria-required = 'true' aria-label = 'Industry' name = 'Industry'>
							<option value = '-None-'>
								-None-
							</option>
							<option value = 'Agricuture'>
								Agricuture
							</option>
							<option value = 'Advertising'>
								Advertising
							</option>
							<option value = 'Digital&#x20;Marketing'>
								Digital Marketing
							</option>
							<option value = 'Education'>
								Education
							</option>
							<option value = 'Engineering'>
								Engineering
							</option>
							<option value = 'MangamentISV'>
								MangamentISV
							</option>
							<option value = 'Fintech'>
								Fintech
							</option>
							<option value = 'FMCG'>
								FMCG
							</option>
							<option value = 'Health&#x20;Care'>
								Health Care
							</option>
							<option value = 'Information&#x20;and&#x20;Technology'>
								Information and Technology
							</option>
							<option value = 'Others'>
								Others
							</option>
						</select>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<input type = 'text' type = 'hidden' style = 'display: none;' name = 'aG9uZXlwb3Q' value = ''/>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab'>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'submit' id = 'formsubmit' role = 'button' class = 'formsubmit zcwf_button' value = 'Contact Sales' aria-label = 'Submit' title = 'Submit'>
							</div>
						</div>
						<script>
							function addAriaSelected6383044000000668002 (){
								var optionElem = event.target;
								var previousSelectedOption = optionElem.querySelector ( '[aria-selected=true]' );
								if ( previousSelectedOption ){
									previousSelectedOption.removeAttribute ( 'aria-selected' );
								}
								optionElem.querySelectorAll ( 'option' )[ optionElem.selectedIndex ].ariaSelected = 'true';
							}
							function validateEmail6383044000000668002 (){
								var form = document.forms[ 'WebToLeads6383044000000668002' ];
								var emailFld = form.querySelectorAll ( '[ftype=email]' );
								var i;
								for ( i = 0; i < emailFld.length; i++ ){
									var emailVal = emailFld[ i ].value;
									if ((emailVal.replace( /^\s+|\s+$/g,'' )).length != 0 ){
										var atpos = emailVal.indexOf ( '@' );
										var dotpos = emailVal.lastIndexOf ( '.' );
										if ( atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length ){
											alert ( 'Please enter a valid email address. ' );
											emailFld[ i ].focus ();
											return false;
										}
									}
								}
								return true;
							}
							function checkMandatory6383044000000668002 (){
								var mndFileds = new Array ( 'Company', 'First Name', 'Last Name', 'Email', 'Phone', 'Industry', 'Country' );
								var fldLangVal = new Array ( 'Company', 'First\x20Name', 'Last\x20Name', 'Email', 'Phone', 'Industry', 'Country' );
								for ( i = 0; i < mndFileds.length; i++ ){
									var fieldObj = document.forms[ 'WebToLeads6383044000000668002' ][ mndFileds[ i ]];
									if ( fieldObj ){
										if (((fieldObj.value ).replace( /^\s+|\s+$/g,'' )).length == 0 ){
											if ( fieldObj.type == 'file' ){
												alert ( 'Please select a file to upload.' );
												fieldObj.focus ();
												return false;
											}
											alert ( fldLangVal[ i ] + ' cannot be empty.' );
											fieldObj.focus ();
											return false;
										}
										else if ( fieldObj.nodeName == 'SELECT' ){
											if ( fieldObj.options[fieldObj.selectedIndex].value == '-None-' ){
												alert ( fldLangVal[ i ] + ' cannot be none.' );
												fieldObj.focus ();
												return false;
											}
										}
										else if ( fieldObj.type == 'checkbox' ){
											if ( fieldObj.checked == false ){
												alert ( 'Please accept  ' + fldLangVal[ i ]);
												fieldObj.focus ();
												return false;
											}
										}
										try {
											if ( fieldObj.name == 'Last Name' ){
												name = fieldObj.value;
											}
										}
										catch ( e ){}
									}
								}
								if ( !validateEmail6383044000000668002()){
									return false;
								}
								var urlparams = new URLSearchParams ( window.location.search );
								if ( urlparams.has( 'service' ) && ( urlparams.get( 'service' ) === 'smarturl' )){
									var webform = document.getElementById ( 'webform6383044000000668002' );
									var service = urlparams.get ( 'service' );
									var smarturlfield = document.createElement ( 'input' );
									smarturlfield.setAttribute ( 'type', 'hidden' );
									smarturlfield.setAttribute ( 'value', service );
									smarturlfield.setAttribute ( 'name', 'service' );
									webform.appendChild ( smarturlfield );
								}
								document.querySelector ( '.crmWebToEntityForm .formsubmit' ).setAttribute ( 'disabled', true );
							}
							function tooltipShow6383044000000668002 ( el ){
								var tooltip = el.nextElementSibling;
								var tooltipDisplay = tooltip.style.display;
								if ( tooltipDisplay == 'none' ){
									var allTooltip = document.getElementsByClassName ( 'zcwf_tooltip_over' );
									for ( i = 0; i < allTooltip.length; i++ ){
										allTooltip[ i ].style.display = 'none';
									}
									tooltip.style.display = 'block';
								}
								else {
									tooltip.style.display = 'none';
								}
							}
						</script>
					</form>
				</div>
    `

    return (
        <section className='my-16 lg:my-32 lg:max-w-[1440px] mx-auto'>
            <div className='mx-[6%] lg:mx-[5%]'>
                <p className='text-[#454444] text-2xl lg:text-5xl font-bold text-center'>We would love to hear from you!</p>
                <p className='mt-5 text-base lg:text-xl text-center'>Let us handle your next campaign.</p>
                <div className='lg:flex items-end justify-between space-y-4 lg:space-y-0 mt-2 bg-[#F4C9CA] rounded-2xl'>
                    <StaticImage
                        src='../images/form-image.png'
                        alt='form image'
                        className='hidden lg:block lg:w-[700px] lg:h-[645px] rounded-2xl'
                        placeholder="blurred"
                        quality="100"
                    />
                    <div className='lg:pr-6 mx-2 py-6 flex justify-center'>
                        <div className='bg-white rounded-2xl lg:w-[500px] pt-6 px-5 lg:px-11 pb-6 h-full ' dangerouslySetInnerHTML={{ __html: contactForm }}>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactForm